/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { takeEvery } from 'redux-saga/effects';

import * as actionsActionTypes from '@ibm-watson/shared/modules/actions/store/actions/actionTypes';
import * as modelsActionTypes from '@ibm-watson/shared/modules/actions/store/models/actions/actionTypes';
import * as operations from '@ibm-watson/shared/modules/ia/store/operations';
import * as dialogTryItActionTypes from '../../../dialog/store/dialog-try-it/actionTypes';
import { SkillTrainingStatus } from '../../util/trainingStatusPollingMachine';
import * as entityActionType from '../entities/actionTypes';
import * as intentActionType from '../intents/actionTypes';
import * as actions from './actions';

export function* setTrainingState() {
  if (actions.pollingMachine) {
    actions.pollingMachine.updateTrainingStatus(SkillTrainingStatus.TRAINING);
    yield true;
  }
  yield false;
}

export default function* rootSaga() {
  const operationList = [
    operations.CREATE,
    operations.UPDATE,
    operations.DELETE
  ];
  const actionTypeList = [
    intentActionType.IMPORT_INTENTS_SUCCESS,
    entityActionType.IMPORT_ENTITIES_SUCCESS
  ];
  const nonTrainingActionTypes = [
    actionsActionTypes.CREATE_EMPTY_ACTION,
    modelsActionTypes.STEP_DEFINE_CUSTOMER_RESPONSE,
    modelsActionTypes.STEP_UPDATE_OPTIONS,
    modelsActionTypes.STEP_REMOVE_CUSTOMER_RESPONSE,
    modelsActionTypes.ACTIONS_ADD_EXAMPLE,
    modelsActionTypes.ACTIONS_ADD_MULTIPLE_EXAMPLES,
    modelsActionTypes.ACTIONS_ADD_MULTIPLE_COUNTER_EXAMPLES,
    modelsActionTypes.ACTIONS_UPDATE_EXAMPLE,
    modelsActionTypes.ACTIONS_DELETE_EXAMPLE,
    modelsActionTypes.SET_DANGER_WORD_VALUES,
    modelsActionTypes.SET_PROFANE_WORD_VALUES,
    dialogTryItActionTypes.TRY_IT_SEND_MESSAGE_START,
    dialogTryItActionTypes.TRY_IT_SEND_MESSAGE_SUCCESS
  ];
  yield takeEvery(
    action =>
      (action.payload &&
        operationList.includes(action.payload.operation) &&
        !nonTrainingActionTypes.includes(action.type) &&
        // creating a new step should only trigger training when autosave is enabled
        !(
          action.type === modelsActionTypes.STEP_CREATE &&
          !action.payload.autoSaveEnabled
        ) &&
        !(
          (action.type ===
            dialogTryItActionTypes.TRY_IT_INITIALIZE_CHAT_START ||
            action.type ===
              dialogTryItActionTypes.TRY_IT_INITIALIZE_CHAT_SUCCESS) &&
          action.skipTraining
        )) ||
      actionTypeList.includes(action.type),
    setTrainingState
  );
}
